import Vue from 'vue'
import App from './App.vue'
import VueFullPage from 'vue-fullpage.js'
import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm';
import { VueReCaptcha } from 'vue-recaptcha-v3';

import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap-vue/dist/bootstrap-vue.css"

Vue.use(VueFullPage);
Vue.use(BootstrapVue);
Vue.use(VueReCaptcha, { siteKey: '6Le4yvsUAAAAABrf989X2ynDsFFcOFSwBz4rccXR' })


Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
